import React,{useContext} from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import {green, blue, red, purple} from '@mui/material/colors';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  Typography,
  IconButton,
  Drawer,
  Button,
  Avatar,
  MenuItem,
  ListItemText,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import Menu from '../../CommonComponents/Menu';
import Snackbar from '../../CommonComponents/Snackbar';

import {RequestStatusId} from '../../../ApplicationConfig/constants'

import {UserInfoContext} from '../../../StateObjects/UserInfoContext';
import {AnalystMenu} from '../../Dashboard/Common/ContextMenu';

import {FormatPhoneNumber,handleInitials} from '../../../Utilities/functions';

import {
  DialogNoLead,
  DialogAssign
} from '../../CommonComponents/DialogBox';

import {Auth} from '../../../Api/auth';
import { useMsal } from "@azure/msal-react";

const PREFIX = 'ManageTeamDrawer';

const classes = {
  root: `${PREFIX}-root`,
  drawer: `${PREFIX}-drawer`,
  drawerHeader: `${PREFIX}-drawerHeader`,
  drawerLabel: `${PREFIX}-drawerLabel`,
  drawerContent: `${PREFIX}-drawerContent`,
  drawerSection: `${PREFIX}-drawerSection`,
  listIcon: `${PREFIX}-listIcon`,
  footer: `${PREFIX}-footer`,
  footerBtns: `${PREFIX}-footerBtns`,
  vettingSection: `${PREFIX}-vettingSection`,
  vettingRow: `${PREFIX}-vettingRow`,
  vettingColumn: `${PREFIX}-vettingColumn`,
  vettingText: `${PREFIX}-vettingText`,
  analystListing: `${PREFIX}-analystListing`,
  avatar: `${PREFIX}-avatar`,
  widthAuto: `${PREFIX}-widthAuto`,
  textNowrap: `${PREFIX}-textNowrap`,
  justifyStart: `${PREFIX}-justifyStart`
};

const StyledDrawer = styled(Drawer)((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {
    '& .MuiLink-root:focus': {
      border: 'none',
    },
  },

  [`& .${classes.drawer}`]: {
    '& .MuiPaper-root.MuiDrawer-paper': {
      width: DRAWER_WIDTH,
      boxSizing: 'border-box',
      overflow: 'hidden',
    },
  },

  [`& .${classes.drawerHeader}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[0],
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.divider,
    zIndex: 500,
    width: DRAWER_WIDTH,
    boxSizing: 'border-box',
    padding: theme.spacing(1.5, 3),
  },

  [`& .${classes.drawerLabel}`]: {
    textTransform: 'uppercase',
  },

  [`& .${classes.drawerContent}`]: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: `calc(100vh - ${theme.spacing(16)})`,
  },

  [`& .${classes.drawerSection}`]: {
    'paddingTop': theme.spacing(3),
    'flexShrink': 0,
    '&:first-of-type': {
      padding: 0,
    },
  },

  [`& .${classes.listIcon}`]: {
    color: theme.palette.common.black,
  },

  [`& .${classes.footer}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: theme.spacing(1.75, 3),
    borderTop: '1px solid',
    borderTopColor: theme.palette.divider,
    width: '400px',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.common.white,
    zIndex: 500,
  },

  [`& .${classes.footerBtns}`]: {
    marginLeft: theme.spacing(2),
  },

  [`& .${classes.vettingSection}`]: {
    display: 'flex',
    flexFlow: 'column',
    padding: theme.spacing(3),
    overflowY: 'auto',
  },

  [`& .${classes.vettingRow}`]: {
    'display': 'flex',
    'padding': theme.spacing(1.5, 0),
    'flexFlow': 'row',
    'height': 'auto',
    'justifyContent': 'center',
    'width': '100%',
    'alignItems': 'center',
    '&:first-of-type': {
      paddingTop: 0,
    },
    '&:last-child': {
      paddingBottom: 0,
    },
  },

  [`& .${classes.vettingColumn}`]: {
    'display': 'flex',
    'flexDirection': 'column',
    'width': '100%',
    'justifyContent': 'center',
    'marginRight': theme.spacing(1),
    'height': '100%',
    '&:last-child': {
      marginRight: 0,
    },
  },

  [`& .${classes.vettingText}`]: {
    paddingLeft: theme.spacing(2),
  },

  [`& .${classes.analystListing}`]: {
    display: 'flex',
    flexFlow: 'column',
    marginRight: 'auto',
  },

  [`& .${classes.avatar}`]: {
    color: theme.palette.grey[100],
  },

  [`& .${classes.widthAuto}`]: {
    width: 'auto !important',
  },

  [`& .${classes.textNowrap}`]: {
    whiteSpace: 'nowrap',
  },

  [`& .${classes.justifyStart}`]: {
    justifyContent: 'flex-start',
  }
}));

const DRAWER_WIDTH = 400;

export default function ManageTeamDrawer({clickHandler, open,data,setBackdropOpen,...props}) {
  const colors = [green[500], blue[500], red[500], purple[500]];


  const {t} = useTranslation();
  const {userInfo} = useContext(UserInfoContext);
  const {instance}=useMsal();

  const initAnalystList=()=>{
    let analystLists=[]
    let index=0

    if (data.leadAnalyst!=undefined && data.leadAnalyst.account != undefined && data.leadAnalyst.account.length >0){
      analystLists.push({avatar:colors[index++ % colors.length] , firstName:data.leadAnalyst.firstName,lastName:data.leadAnalyst.lastName, name: data.leadAnalyst.fullName,email:data.leadAnalyst.email, phone:data.leadAnalyst.phoneNumber, current:userInfo.id==data.leadAnalyst.account ,account: data.leadAnalyst.account,role:'lead',assigned:true})
    }
    data.supportAnalysts.forEach(el=>analystLists.push({ avatar:colors[index++ % colors.length],firstName: el.firstName, lastName:el.lastName,name: el.fullName, email:el.email,phone:el.phoneNumber,current:userInfo.id==el.account, account: el.account,role:'support',assigned:true}))
    
    if (analystLists.filter((analyst)=> analyst.account==userInfo.id).length==0)
    {
      analystLists.push({avatar:colors[index++ % colors.length], firstName:userInfo.firstName,lastName:userInfo.lastName,name: userInfo.fullName, email:userInfo.email,phone:'',current:true, account: userInfo.id,role:'support',assigned:false})
    }
    return analystLists;
  }

  let analystLists=initAnalystList()
  const [analysts, setAnalysts] = React.useState(analystLists);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [readOnly,setReadOnly] = React.useState(false);
  const [snackbarLeave, setSnackbarLeave] = React.useState({
    open: false,
    severity: "success",
    message: ""
  });

  const refreshAssign=(analystsList=analysts)=>{

    const current = analystsList.filter((analyst) => analyst.current);
    return (current.length >0 && !current[0].assigned)

  }
  const [assign, setAssign] = React.useState(() => {
    refreshAssign()
  });

  const [dialog, setOpen] = React.useState({
    noLead: false,
    assignAsLead: false,
    assignAsSupport: false,
  });

  const handleCloseSnackbarLeave=()=>{
    setSnackbarLeave({...snackbarLeave, open: false, message: ""});
  }

  const handleUpdateAssignedAnalysts=()=>{

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ analysts: analysts, request_id:data.requestId})
    };
    let success=true;
    setBackdropOpen(true)
    //send the analyst list to the backend
    Auth.authorizedFetch("/api/updateAssignedAnalysts", requestOptions,instance)
    .then(res => res.json())
    .then((result) => {
        setBackdropOpen(false)
        if (result.statusCode!=200){
          //DELAY ADDED SO SNACKBAR WILL BE ANNOUNCED AFTER DRAWER CLOSES
          setTimeout(function() {
            setSnackbarLeave({open: true, severity: "error", message: t("applicationErrorMessage.generic." + result.customMessageKey)});
          }, 10);
          success=false
        }else {
          setAnalysts(analystLists);
          //DELAY ADDED SO SNACKBAR WILL BE ANNOUNCED AFTER DRAWER CLOSES
          setTimeout(function() {
            setSnackbarLeave({open: true, severity: "success", message: t("notifications.assignedAnalystsUpdated")});
          }, 10);
          if(props.refreshRow){
            props.refreshRow(result.data);
          }
          if(props.refreshRequest){
            props.refreshRequest();
          }
        }
    })
    .catch(()=>{
      setBackdropOpen(false)
      //DELAY ADDED SO SNACKBAR WILL BE ANNOUNCED AFTER DRAWER CLOSES
      setTimeout(function() {
        setSnackbarLeave({open: true, severity: "error", message: t("applicationErrorMessage.generic.dataError")});
      }, 10);
      success=false
    })

    return success;
  }

  React.useEffect(()=>{

    if (!open.manageTeamDrawer){
    
      let analystLists=initAnalystList()
      setAnalysts(analystLists)
      setReadOnly(data.statusId==undefined || (data.statusId==RequestStatusId.Approved || data.statusId==RequestStatusId.Denied || data.statusId==RequestStatusId.Withdrawn))
      setAssign(refreshAssign(analystLists))
    }
  },[data.leadAnalyst,data.supportAnalysts])
  
  React.useEffect(()=>{
    handleCloseSnackbarLeave();
  }, [open])

  const applyChanges=(noLeadConfirm=false)=>{
    let isLead = false;
    analysts.forEach((analyst) => {
      if (analyst.role === 'lead') {
        isLead = true;
      }
    });
    if (!isLead && !noLeadConfirm) {
      toggleDialog('noLead', !dialog.noLead);
    } else { 
      handleUpdateAssignedAnalysts()
      clickHandler();
    }
  }

  const cancelChanges=()=>{
    setAnalysts(analystLists)
    setAssign(refreshAssign(analystLists))
    clickHandler()
  }

  const makeLead = (value) => () => {
    setAnalysts(
      analysts.map((item) => 
      {
        if (item.role==='lead'){
          return {...item, role: 'support'} 
        }
        
        if (item.account === value.account){
          return  {...item, role: 'lead'}
        }
        
        return item
        
        
      }

      ));
  };

  const makeSupport = (value) => () => {
    setAnalysts(
      analysts.map((item) =>
        item.account === value.account ?
        {...item, role: 'support'} :
        item,
      ));
  };

  const unassignRequest = (value) => () => {
    setAnalysts(
        analysts.map((item) =>
        item.account === value.account ?
        {...item, assigned: false, role: 'support'} :
        item,
        )
    );
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleBlur=(event)=> {
    if (event.key === 'Tab') {
      event.preventDefault();
      setAnchorEl(null);
    }
  }

  const handleAvatarStyle = (value) => {
    return {
      backgroundColor: value,
    };
  };

  const toggleDialog = (state, value) => {
    setOpen({...dialog, [state]: value});
    handleClose();
  };

  const toggleAssignMeMenu = (value) => {
    if (value.current && value.assigned) {
      setAssign(true);
    } else if (value.current && !value.assigned) {
      setAssign(false);
    }
  };

  const handleAssignMeAs = (value, role) => {
    const current = analysts.filter((analyst) => analyst.current);
    setAnalysts(
        analysts.map((item) =>
        {
          if (item.role === 'lead' && (current[0].account != item.account && role=='lead')){
            return {...item, role: 'support'}
          }
          if (item.account === current[0].account){
            return  {...item, assigned: true, role: role, phone: value.replace('+','').replace('(','').replace(')','').replace(/\s+/g, '')}
          }

          return item;
        }
 
        ),
    );
    setAssign(false);
  };

  const leadAnalysts = () => {
    const content = analysts
        .filter((analyst) => analyst.assigned && analyst.role === 'lead')
        .map((analyst, index) => {
          return (
            <div id={`lead-${index}`} className={classes.vettingRow} key={analyst.account}>
              <Avatar
                style={handleAvatarStyle(analyst.avatar)}
                className={classes.avatar}
              >
                {handleInitials(analyst.firstName,analyst.lastName)}
              </Avatar>
              <div className={classes.analystListing}>
                <Typography className={classes.vettingText} variant="body2">
                  {analyst.name}
                  {analyst.current ? t('assigneeDrawer.you') : false}
                </Typography>
                <Typography className={classes.vettingText} variant="body2">
                  {analyst.email}
                </Typography>
                <Typography className={classes.vettingText} variant="body2">
                  +{FormatPhoneNumber(analyst.phone)}
                </Typography>
              </div>
              {!readOnly && <AnalystMenu
                role={'lead'}
                makeSupport={makeSupport(analyst)}
                unassignRequest={unassignRequest(analyst)}
                controls={index}
                current={analyst.current}
                toggleAssignMeMenu={() => toggleAssignMeMenu(analyst)}
              />}
            </div>
          );
        });
    if (content.length > 0) {
      return content;
    } else {
      return (
        <div className={clsx(classes.vettingRow, classes.justifyStart)}>
          <Avatar className={classes.pink}>
            <PersonIcon />
          </Avatar>
          <Typography variant="body2" color="textSecondary" sx={{ml: 2}}>
            {t('assigneeDrawer.noLeadAssigned')}
          </Typography>
        </div>
      );
    }
  };

  const supportAnalysts = () => {
    const sortedAnalysts = analysts.sort((a, b) =>
      a.name.localeCompare(b.name),
    ); // sorts supported analysts alphabetically

    const content = sortedAnalysts
        .filter((analyst) => analyst.assigned && analyst.role === 'support')
        .map((analyst, index) => {
          return (
            <div id={`support-${index}`} className={classes.vettingRow} key={analyst.account}>
              <Avatar
                style={handleAvatarStyle(analyst.avatar)}
                className={classes.avatar}
              >
                {handleInitials(analyst.firstName,analyst.lastName)}
              </Avatar>
              <div className={classes.analystListing}>
                <Typography className={classes.vettingText} variant="body2">
                  {analyst.name}
                  {analyst.current ? ' (You)' : false}
                </Typography>
                <Typography className={classes.vettingText} variant="body2">
                  {analyst.email}
                </Typography>
                <Typography className={classes.vettingText} variant="body2">
                +{FormatPhoneNumber(analyst.phone)}
                </Typography>
              </div>
              {!readOnly && <AnalystMenu
                role={'support'}
                makeLead={makeLead(analyst)}
                unassignRequest={unassignRequest(analyst)}
                controls={index}
                current={analyst.current}
                toggleAssignMeMenu={() => toggleAssignMeMenu(analyst)}
              />}
            </div>
          );
        });
    if (content.length > 0) {
      return content;
    } else {
      return (
        <div className={clsx(classes.vettingRow, classes.justifyStart)}>
          <Avatar className={classes.pink}>
            <PersonIcon />
          </Avatar>
          <Typography variant="body2" color="textSecondary" sx={{ml: 2}}>
            {t('assigneeDrawer.noSupportAssigned')}
          </Typography>
        </div>
      );
    }
  };

  const content = () => (
    <div className={classes.root}>
      <div className={classes.drawerHeader}>
        <Typography component="h2" variant="h6">
        {t('assigneeDrawer.manageAssignees')}
        </Typography>
        <IconButton
          onClick={cancelChanges}
          edge="end"
          id="details-close"
          aria-label={t('dialog.close')}
          size="large">
          <CloseIcon />
        </IconButton>
      </div>
      <div className={classes.drawerContent}>
        <div className={classes.vettingSection}>
          <div className={classes.vettingRow}>
            <div className={classes.vettingColumn}>
              <Typography variant="subtitle1" component="h3">
                {t('assigneeDrawer.assignees')}
              </Typography>
            </div>
            <div className={clsx(classes.vettingColumn, classes.widthAuto)}>
              {assign && !readOnly && (
                <>
                  <Button
                    id="assign-as-btn"
                    aria-controls="assign-as-menu"
                    aria-haspopup="true"
                    onClick={handleClick}
                    className={clsx(
                        classes.textNowrap,
                        'MuiIconButton-edgeEnd',
                    )}
                    color="primary"
                  >
                    {t('assigneeDrawer.assignMeAs')}
                    <ArrowDropDownIcon />
                  </Button>
                  <Menu
                    id="assign-as-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    handleClose={handleClose}
                    handleBlur={handleBlur}
                    content={[
                      <MenuItem
                        key="assign-lead-item"
                        id="assign-lead-item"
                        onClick={() => {
                          toggleDialog('assignAsLead', !dialog.assignAsLead);
                        }}
                      >
                        <ListItemText
                          primary={
                            <Typography variant="body2">
                              {t('assigneeDrawer.assignMeAsLead')}
                            </Typography>
                          }
                        />
                      </MenuItem>,
                      <MenuItem
                        key="assign-support-item"
                        id="assign-support-item"
                        onClick={() => {
                          toggleDialog(
                              'assignAsSupport',
                              !dialog.assignAsSupport,
                          );
                        }}
                      >
                        <ListItemText
                          primary={
                            <Typography variant="body2">
                              {t('assigneeDrawer.assignMeAsSupport')}
                            </Typography>
                          }
                        />
                      </MenuItem>
                    ]}
                  />
                </>
              )}
            </div>
          </div>
          <div className={classes.vettingRow}>
            <div className={classes.vettingColumn}>
              <Typography variant="subtitle2" component="h4">
                {t('assigneeDrawer.lead')}
              </Typography>
            </div>
          </div>
          <div className={classes.vettingRow}>
            <div className={classes.vettingColumn}>{leadAnalysts()}</div>
          </div>
          <div className={classes.vettingRow}>
            <div className={classes.vettingColumn}>
              <Typography variant="subtitle2" component="h4">
                {t('assigneeDrawer.support')}
              </Typography>
            </div>
          </div>
          <div className={classes.vettingRow}>
            <div className={classes.vettingColumn}>{supportAnalysts()}</div>
          </div>
        </div>
      </div>
      {!readOnly && <div className={classes.footer}>
        <Button
          id="assigneeDrawer-cancel-btn"
          variant="outlined"
          color="primary"
          className={classes.footerBtns}
          onClick={cancelChanges}
        >
          {t('assigneeDrawer.cancel')}
        </Button>
        <Button
          id="assigneeDrawer-confirm-btn"
          variant="contained"
          color="primary"
          className={classes.footerBtns}
          onClick={() => {
            applyChanges();
          }}
        >
          {t('assigneeDrawer.apply')}
        </Button>
      </div>}
    </div>
  );

  return (
    <div>
      <StyledDrawer
        anchor="right"
        open={open}
        onKeyUp={(e) => {
          if (e.key === 'Escape') {
            cancelChanges();
          }
        }}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            toggleDialog();
          }
        }}
        variant="temporary"
        className={classes.drawer}
      >
        {content()}
      </StyledDrawer>
      <DialogNoLead
        open={dialog.noLead}
        toggleDialog={() => toggleDialog('noLead', !dialog.noLead)}
        handleSubmit={() => {
          toggleDialog('noLead', !dialog.noLead)
          applyChanges(true);
        }}
        text={{
          title: t('dialog.noLeadNoLeadAssigned'),
          titleClose: t('dialog.noLeadNoLeadClose'), 
          main: t('dialog.noLeadMainText'), 
          submit: t('dialog.noLeadContinue')
        }}
      />
      <DialogAssign
        open={dialog.assignAsLead}
        toggleDialog={() => toggleDialog('assignAsLead', !dialog.assignAsLead)}
        handleAssignMeAs={handleAssignMeAs}
        isAssignLead={true}
      />
      <DialogAssign
        open={dialog.assignAsSupport}
        toggleDialog={() =>
          toggleDialog('assignAsSupport', !dialog.assignAsSupport)
        }
        handleAssignMeAs={handleAssignMeAs}
        isAssignLead={false}
      />
      <Snackbar 
        message={snackbarLeave.message}
        severity={snackbarLeave.severity}
        open={snackbarLeave.open}
        handleClose={handleCloseSnackbarLeave}
      />
    </div>
  );
}
ManageTeamDrawer.propTypes={
  clickHandler: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  setBackdropOpen: PropTypes.func.isRequired,
  refreshRow: PropTypes.func,
  refreshRequest: PropTypes.func,
}